import { Form, Input, Radio, Row, Select } from "antd";
import { useCallback } from "react";
import { toast } from "react-toastify";

import { CepService } from "../../../../services/cep.service";
import { listCidades } from "../../../../utils/getCidades";
import { InputPhone } from "../InputPhone";
import { InputMatricula } from "../../../../components/InputMatricula";
import { InputCep } from "../InputCep";
import {
  listCargosAESP,
  listCargosCBMCE,
  listCargosOUTROS,
  listCargosPCCE,
  listCargosPEFOCE,
  listCargosPMCE,
  listCargosSSPDS,
  listCargosSUPESP,
} from "../../../../utils/getCargos";
import { listOrgaosOutros } from "../../../../utils/getOrgaosOutros";

const { Option } = Select;

export function Endereco({ form, setLoading }) {
  const getAddress = useCallback(
    async (cep) => {
      setLoading(true);

      try {
        const patt1 = /[0-9]/g;
        const cepFormatado = cep.match(patt1).join("");
        const { data } = await CepService.get({ cep: cepFormatado });
        const { bairro, id, municipio, rua, tipo, uf } = data;

        const findCidade = listCidades.find(
          (v) => v.nome.toLocaleLowerCase() === municipio.toLocaleLowerCase()
        );
        form.setFieldsValue({
          bairro,
          cep,
          id,
          cidade: findCidade ? findCidade.nome : null,
          endereco: rua,
          tipo,
          uf,
        });
      } catch (err) {
        toast.error(
          "CEP  não encontrado na base, digite endereço manualmente!"
        );
      } finally {
        setLoading(false);
      }
    },
    [form, setLoading]
  );

  return (
    <>
      <Row justify="center" align="middle">
        <div className="ant-descriptions-title">Endereço</div>
      </Row>
      <br />

      <div className="duasCollumn">
        <Form.Item
          className="inputStyle"
          label="CEP"
          name="cep"
          rules={[{ required: true, message: "Por favor informe seu CEP!" }]}
        >
          <InputCep
            onBlur={(e) => {
              const cep = e.target.value;
              if (cep) {
                getAddress(cep);
              }
            }}
          />
        </Form.Item>

        <div className="sizeBoxWidth" />

        <Form.Item
          className="inputStyle"
          label="Endereço"
          name="endereco"
          rules={[{ required: true, message: "Por favor informe o endereço!" }]}
        >
          <Input />
        </Form.Item>

        <div className="sizeBoxWidth" />

        <Form.Item
          className="inputStyleNumero"
          label="Numero"
          name="numero"
          rules={[{ required: true, message: "Por favor informe o Número!" }]}
        >
          <Input />
        </Form.Item>
      </div>

      <div className="duasCollumn">
        <Form.Item
          className="inputStyleNumero"
          label="Complemento"
          name="complemento"
        >
          <Input />
        </Form.Item>

        <div className="sizeBoxWidth" />

        <Form.Item
          className="inputStyle"
          label="Bairro"
          name="bairro"
          rules={[{ required: true, message: "Por favor informe o bairro!" }]}
        >
          <Input />
        </Form.Item>

        <div className="sizeBoxWidth" />

        {/* <Form.Item
          label="UF"
          name="estado"
          rules={[{ required: true, message: "Por favor informe seu RG!" }]}
        >
          <Select
            showSearch
            optionFilterProp="children"
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
          >
            {listUF.map((lista) => {
              return (
                <Option key={lista.id} value={lista.sigla}>
                  {lista.sigla}
                </Option>
              );
            })}
          </Select>
        </Form.Item> */}

        <Form.Item
          className="inputStyle"
          label="Cidade"
          name="cidade"
          rules={[{ required: true, message: "Por favor informe a cidade!" }]}
        >
          <Select
            showSearch
            optionFilterProp="children"
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
          >
            {listCidades.map((lista) => {
              return (
                <Option key={lista.id} value={lista.nome}>
                  {lista.nome}
                </Option>
              );
            })}
          </Select>
        </Form.Item>
      </div>

      <Form.Item
        className="inputStyle"
        label="Órgão lotação"
        name="orgao"
        rules={[{ required: true, message: "Por favor informe o Orgão!" }]}
      >
        <Radio.Group>
          {[
            "SSPDS",
            "PCCE",
            "PMCE",
            "CBMCE",
            "PEFOCE",
            "SUPESP",
            "AESP",
            "OUTROS",
          ].map((r, index) => (
            <Radio key={index} value={r}>
              {r}
            </Radio>
          ))}
        </Radio.Group>
      </Form.Item>

      <Form.Item
        className="inputStyle"
        shouldUpdate={(old, current) => old.orgao !== current.orgao}
      >
        {({ getFieldValue }) => {
          if (getFieldValue("orgao") === "OUTROS") {
            return (
              <Form.Item
                label="Informe o órgão lotação"
                name="orgaoLotacao"
                rules={[
                  {
                    required: true,
                    message: "Por favor, informe o órgão lotação!",
                  },
                ]}
              >
                <Input />
                {/* <Select
                  showSearch
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                >
                  {listOrgaosOutros.map((orgaos) => (
                    <Option key={orgaos.id} value={orgaos.orgao}>
                      {orgaos.orgao}
                    </Option>
                  ))}
                </Select> */}
              </Form.Item>
            );
          }
          return <div />;
        }}
      </Form.Item>
      <div className="duasCollumn">
        <Form.Item
          className="inputStyle"
          label="Unidade Lotação"
          name="unidadeLotacao"
          rules={[{ required: true, message: "Por favor informe a Lotação!" }]}
        >
          <Input />
        </Form.Item>

        <div className="sizeBoxWidth" />

        <Form.Item
          className="inputStyle"
          label="Telefone lotação"
          name="telefoneLotacao"
          rules={[{ required: true, message: "Por favor informe o Telefone!" }]}
        >
          <InputPhone />
        </Form.Item>
      </div>

      <div className="duasCollumn">
        <Form.Item
          className="inputStyle"
          shouldUpdate={(oldValues, currentValues) =>
            oldValues.orgao !== currentValues.orgao
          }
        >
          {({ getFieldValue }) => {
            const orgaoFieldValue = getFieldValue("orgao");

            // Se orgaoFieldValue não estiver definido, renderiza o campo Cargo com uma opção default
            if (!orgaoFieldValue) {
              return (
                <Form.Item
                  className="inputStyle"
                  span={10}
                  label="Cargo(Informe o orgão)"
                  name="cargo"
                  rules={[
                    {
                      required: true,
                      message: "Por favor informe o seu Cargo!",
                    },
                  ]}
                >
                  <Select disabled>
                    <Option value="">Selecione um órgão primeiro</Option>
                  </Select>
                </Form.Item>
              );
            }

            // Caso contrário, renderiza o campo Cargo correspondente ao orgao selecionado
            switch (orgaoFieldValue) {
              case "PCCE":
                return (
                  <Form.Item
                    className="inputStyle"
                    span={10}
                    label="Cargo"
                    name="cargo"
                    rules={[
                      {
                        required: true,
                        message: "Por favor informe o seu Cargo!",
                      },
                    ]}
                  >
                    <Input />
                    {/* <Select
                      showSearch
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        option.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }
                    >
                      {listCargosPCCE.map((cargo) => (
                        <Option key={cargo.id} value={cargo.cargos}>
                          {cargo.cargos}
                        </Option>
                      ))}
                    </Select> */}
                  </Form.Item>
                );
              case "PMCE":
                return (
                  <Form.Item
                    className="inputStyle"
                    span={10}
                    label="Cargo"
                    name="cargo"
                    rules={[
                      {
                        required: true,
                        message: "Por favor informe o seu Cargo!",
                      },
                    ]}
                  >
                    <Input />
                    {/* <Select
                      showSearch
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                      }
                    >
                      {listCargosPMCE.map((cargo) => (
                        <Option key={cargo.id} value={cargo.cargos}>
                          {cargo.cargos}
                        </Option>
                      ))}
                    </Select> */}
                  </Form.Item>
                );
              case "SSPDS":
                return (
                  <Form.Item
                    className="inputStyle"
                    span={10}
                    label="Cargo"
                    name="cargo"
                    rules={[
                      {
                        required: true,
                        message: "Por favor informe o seu Cargo!",
                      },
                    ]}
                  >
                    <Input />
                    {/* <Select
                      showSearch
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                      }
                    >
                      {listCargosSSPDS.map((cargo) => (
                        <Option key={cargo.id} value={cargo.cargos}>
                          {cargo.cargos}
                        </Option>
                      ))}
                    </Select> */}
                  </Form.Item>
                );

              case "CBMCE":
                return (
                  <Form.Item
                    className="inputStyle"
                    span={10}
                    label="Cargo"
                    name="cargo"
                    rules={[
                      {
                        required: true,
                        message: "Por favor informe o seu Cargo!",
                      },
                    ]}
                  >
                    <Input />
                    {/* <Select
                      showSearch
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                      }
                    >
                      {listCargosCBMCE.map((cargo) => (
                        <Option key={cargo.id} value={cargo.cargos}>
                          {cargo.cargos}
                        </Option>
                      ))}
                    </Select> */}
                  </Form.Item>
                );

              case "PEFOCE":
                return (
                  <Form.Item
                    className="inputStyle"
                    span={10}
                    label="Cargo"
                    name="cargo"
                    rules={[
                      {
                        required: true,
                        message: "Por favor informe o seu Cargo!",
                      },
                    ]}
                  >
                    <Input />
                    {/* <Select
                      showSearch
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                      }
                    >
                      {listCargosPEFOCE.map((cargo) => (
                        <Option key={cargo.id} value={cargo.cargos}>
                          {cargo.cargos}
                        </Option>
                      ))}
                    </Select> */}
                  </Form.Item>
                );

              case "SUPESP":
                return (
                  <Form.Item
                    className="inputStyle"
                    span={10}
                    label="Cargo"
                    name="cargo"
                    rules={[
                      {
                        required: true,
                        message: "Por favor informe o seu Cargo!",
                      },
                    ]}
                  >
                    <Input />
                    {/* <Select
                      showSearch
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                      }
                    >
                      {listCargosSUPESP.map((cargo) => (
                        <Option key={cargo.id} value={cargo.cargos}>
                          {cargo.cargos}
                        </Option>
                      ))}
                    </Select> */}
                  </Form.Item>
                );

              case "AESP":
                return (
                  <Form.Item
                    className="inputStyle"
                    span={10}
                    label="Cargo"
                    name="cargo"
                    rules={[
                      {
                        required: true,
                        message: "Por favor informe o seu Cargo!",
                      },
                    ]}
                  >
                    <Input />
                    {/* <Select
                      showSearch
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        option.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }
                    >
                      {listCargosAESP.map((cargo) => (
                        <Option key={cargo.id} value={cargo.cargos}>
                          {cargo.cargos}
                        </Option>
                      ))}
                    </Select> */}
                  </Form.Item>
                );

              case "OUTROS":
                return (
                  <Form.Item
                    className="inputStyle"
                    span={10}
                    label="Cargo"
                    name="cargo"
                    rules={[
                      {
                        required: true,
                        message: "Por favor informe o seu Cargo!",
                      },
                    ]}
                  >
                    <Input />
                    {/* <Select
                      showSearch
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        option.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }
                    >
                      {listCargosOUTROS.map((cargo) => (
                        <Option key={cargo.id} value={cargo.cargos}>
                          {cargo.cargos}
                        </Option>
                      ))}
                    </Select> */}
                  </Form.Item>
                );

              default:
                return null; // Retornar null caso não haja nenhum orgao selecionado (embora já tenha sido tratado acima)
            }
          }}
        </Form.Item>

        <div className="sizeBoxWidth" />

        <Form.Item
          className="inputStyle"
          span={10}
          label="Função"
          name="funcao"
          rules={[{ required: true, message: "Por favor, informe a função!" }]}
        >
          <Input />
        </Form.Item>
      </div>

      <Form.Item
        className="inputStyle"
        shouldUpdate={(old, current) => old.orgao !== current.orgao}
      >
        {({ getFieldValue }) => {
          if (getFieldValue("orgao") === "OUTROS") {
            return <div />;
          }
          return (
            <>
              <Row justify="center" align="middle">
                <div className="ant-descriptions-title">Chefe Imediato</div>
              </Row>

              <Form.Item
                className="inputStyle"
                span={10}
                label="Nome: "
                name="chefeImediato"
                rules={[
                  {
                    required: true,
                    message: "Por favor, informe o nome do chefe imediato!",
                  },
                ]}
              >
                <Input />
              </Form.Item>
              <div className="duasCollumn">
                <Form.Item
                  className="inputStyle"
                  label="Telefone"
                  name="telefoneChefeImediato"
                  rules={[
                    {
                      required: true,
                      message: "Por favor informe o Telefone!",
                    },
                  ]}
                >
                  <InputPhone />
                </Form.Item>

                <div className="sizeBoxWidth" />

                <Form.Item
                  className="inputStyle"
                  span={10}
                  label="Matrícula: "
                  name="matriculaChefeImediato"
                  rules={[
                    {
                      required: true,
                      message:
                        "Por favor, informe a mtrícula do chefe imediato!",
                    },
                  ]}
                >
                  <InputMatricula maxLength={7} />
                </Form.Item>

                <div className="sizeBoxWidth" />

                <Form.Item
                  className="inputStyle"
                  span={10}
                  label="E-mail: "
                  name="emailChefeImediato"
                  rules={[
                    {
                      required: true,
                      message: "Por favor, informe o e-mail do chefe imediato!",
                    },
                  ]}
                >
                  <Input />
                </Form.Item>
              </div>
            </>
          );
        }}
      </Form.Item>
    </>
  );
}
